<div class="text-danger text-danger alert-danger fw-bold mt-1 " *ngIf="control && control.errors && (control.dirty || control.touched)">
    <p class="text-danger text-danger alert-danger fw-bold mt-1 " *ngIf="control.errors.required"><small> * This field is required</small></p>
    <p *ngIf="control.errors.unique"><small>{{control.errors.unique}}</small></p>
    <p *ngIf="control.errors.lessThen"><small>{{control.errors.lessThen}}</small></p>
    <p *ngIf="control.errors.greaterThan"><small>{{control.errors.greaterThan}}</small></p>
    <p *ngIf="control.errors.email"><small>{{control.errors.email?'Invaild Email' :''}}</small></p>
    <p *ngIf="control.errors.mobile"><small>{{control.errors.mobile}}</small></p>
    <p *ngIf="control.errors.confirmPassword"><small>{{control.errors.confirmPassword}}</small></p>
    <p *ngIf="control.errors.min"><small>{{'Please choose number in limit '}}</small></p>
</div>
